export const clubColors = [
  {
    club: 'Malmö FF',
    colors: ['#008ACB']
  },
  {
    club: 'IFK Göteborg',
    colors: ['#FCBD00', '#234B9A']
  },
  {
    club: 'AIK',
    colors: ['#003155', '#F5E814']
  },
  {
    club: 'IFK Norrköping',
    colors: ['#194D99', '#AC9961']
  },
  {
    club: 'IF Elfsborg',
    colors: ['#FCC000', '#000000']
  },
  {
    club: 'Helsingborgs IF',
    colors: ['#E2001A', '#006EB2']
  },
  {
    club: 'Djurgårdens IF',
    colors: ['#1964B7', '#FEDD03', '#E53127']
  },
  {
    club: 'Örgryte IS',
    colors: ['#222d60', '#940C23']
  },
  {
    club: 'Halmstads BK',
    colors: ['#FED200', '#172981']
  },
  {
    club: 'Örebro SK',
    colors: ['#E2001A', '#008146', '#000000']
  },
  {
    club: 'Gais',
    colors: ['#FFD300', '#E32219', '#007D32']
  },
  {
    club: 'Hammarby IF',
    colors: ['#F6BB00', '#00963A']
  }
];
